namespace $.$$ {
	export type $easyreels_user_screen = 'recorder' | 'recordings'

	export class $easyreels_user extends $.$easyreels_user {
		@$mol_mem
		account() {
			try {
				return $mol_wire_stale(() => $easyreels_user_me())
			} catch {
				return null
			}
		}

		me() {
			const account = this.account()

			return account ? account.me : account
		}

		override page(): $easyreels_user_screen {
			return this.$.$mol_state_arg.value('page') === 'recordings' ? 'recordings' : 'recorder'
		}

		override bot_uri() {
			return this.account()?.telegramBotURL ?? ''
		}

		override used_bytes() {
			return this.Recordings().used_bytes()
		}

		override limit_bytes() {
			return this.Recordings().limit_bytes()
		}

		override content() {
			const me = this.me()

			if (me === undefined) return [this.Placeholder()]
			if (me === null) return [this.Guest()]
			if (this.page() === 'recordings') return [this.Recorder(), this.Library()]

			return [this.Recorder()]
		}

		override library_head() {
			return [this.Camera_link(), this.Library().Title(), this.Library().Tools()]
		}

		override sign_in(next?: null) {
			if (next === undefined) return null

			this.$.$mol_dom_context.location.href = '/auth/telegram/callback'

			return null
		}

		override sign_out(next?: null) {
			if (next === undefined) return null

			const payload = $easyreels_user_signout().signOut
			this.$.$mol_dom_context.location.href = payload.redirectUrl

			return null
		}
	}
}
